<template lang="pug">
transition(name="fade")
	.v-cookies.cookies(v-if="content && visible" ref="cookies" data-scroll-lock-scrollable :class="{'agree': agree, 'cookies--settings': settings}")
		.cookies__image
			img.cookies__image-icon(:src="content.image.src" :alt="content.image.alt")
		.cookies__content
			.cookies__title(v-if="content.title") {{ content.title }}
			.cookies__text(v-if="content.text" v-html="content.text")
			.cookies__fields(v-if="settings && content.fields")
				v-field.form__field(v-for="(field, idx) in content.fields"
					:key="idx"
					:field="field"
					v-model="field.checkedDefault"
					@update:model-value="fieldChanged(field)"
				)
			.cookies__actions(v-if="content.actions")
				button.btn.btn--gray.btn--sm.cookies__action(type="button" v-if="settings ? content.actions.back : content.actions.settings" @click="handleChangeSettings") {{ settings ? content.actions.back : content.actions.settings }}

				button.btn.btn--primary.btn--sm.cookies__action(type="button" v-if="!settings && content.actions.accept" @click="handleAgreeCookies") {{ content.actions.accept }}
				button.btn.btn--primary.btn--sm.cookies__action(type="button" v-if="settings && content.actions.save" @click="saveCookies") {{ content.actions.save }}
</template>

<script>

import scrollLock from 'scroll-lock';
import sourceMixin from "./mixins/v-mixin-source.vue";

import cookies from "../scripts/helpers/cookies.js";
import isMobMixin from "components/mixins/v-mixin-is-mob.vue";
import {nextTick} from "vue";
import controller from "../scripts/controller/controller.js";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		visibleProp: {
			type: Boolean,
			default: null
		}
	},

	data() {
		return {
			content: null,
			visible: true,
			agree: false,
			settings: false,
			localValue: null,
			options: []
		}
	},

	methods: {
		dataSet(data) {
			this.content = data.items;
		},
		async saveCookies() {
			await cookies.installAgree();
			this.settings = false;
			this.visible = false;
			this.agree = true;
		},
		closeModal() {
			this.settings = false;
			this.visible = false;
		},
		handleChangeSettings() {
			this.settings = !this.settings
		},
		async handleAgreeCookies() {
			this.options = []
			await this.content?.fields.forEach(item => this.options.push({key: item.name, value: item.value, checked: true}))
			this.saveCookies();
		},
		fieldChanged(field) {
			this.options = this.options.filter(option => option.key !== field.name)
			this.options.push({ key: field.name, value: field.value, checked: field.checkedDefault })
		}
	},

	watch: {
		visibleProp(state) {
			this.visible = state;
		},
		content() {
			this.options = [];
			this.content?.fields.forEach(item => this.options.push({key: item.name, value: item.value, checked: item.checkedDefault}))
		},
		options() {
			cookies.setOptions(this.options);
			if(!this.settings) {
				this.visible = !cookies.checkAgree();
			}
		},
		async settings(state) {
			if (state) {
				await nextTick();
				scrollLock.disablePageScroll(this.$refs.cookies);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.cookies);
					this.$emit('close');
				}, 300);
			}
		}
	},

	mounted() {
		controller.events.on('openCookies', () => {this.visible = true, this.settings = true});
	},
}

</script>
